import getLogger from '@ignitesales/logger-es';

const logger = getLogger({ component: 'reduceReducers' });

const reduceReducers = (initialState, reducers = []) => {
  return (previousState = initialState, action) => {
    return reducers.reduce((currentState, reducer) => {
      const nextState = reducer(currentState, action, previousState);
      if (nextState == null) {
        logger.error('Null or missing state returned by a reducer. Perhaps you forgot to return a value!');
        return currentState;
      }

      return nextState;
    }, previousState);
  };
};

export default reduceReducers;
